const GenerateReport = () => import("./views/GenerateReport.vue");
const AllReports = () => import("./views/AllReports.vue");
export default [
  {
    path: "generate",
    name: "generate-hrm-report-user",
    component: GenerateReport,
  },
  {
    path: "all",
    name: "hrm-ess-reports",
    component: AllReports,
  },
];
